const date = new Date('2003-02-05');
const US_DATE_FORMATS = [
  '2/5/2003',
  '02/05/2003',
  // timezones
  '2/4/2003',
  '02/04/2003',
  '2/6/2003',
  '02/06/2003',
];

/**
 * This function checks if the current user browser has date format in US format.
 */
export const checkIsBrowserDateInUsFormat = () =>
  US_DATE_FORMATS.includes(date.toLocaleDateString());
